import { VOICE_PROVIDERS, VOICE_IDS, VOICE_SETTINGS } from '../config/api';

type VoiceProvider = typeof VOICE_PROVIDERS[keyof typeof VOICE_PROVIDERS];

class VoiceService {
  private provider: VoiceProvider;
  private voiceId: string;
  private speechRate: number;

  constructor() {
    this.provider = VOICE_PROVIDERS.NATIVE;
    this.voiceId = '';
    this.speechRate = 1.6; // Aumentado para 1.6x
  }

  setProvider(provider: VoiceProvider, voiceId?: string) {
    this.provider = provider;
    if (voiceId) {
      this.voiceId = voiceId;
    }
  }

  setSpeechRate(rate: number) {
    this.speechRate = rate;
  }

  private nativeSpeak(text: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const utterance = new SpeechSynthesisUtterance(text);
      utterance.lang = 'pt-BR';
      utterance.rate = this.speechRate;
      utterance.pitch = 1;
      
      utterance.onend = () => resolve();
      utterance.onerror = (error) => reject(error);
      
      window.speechSynthesis.speak(utterance);
    });
  }

  private async elevenLabsSpeak(text: string): Promise<void> {
    if (!this.voiceId) {
      throw new Error('Voice ID not set for ElevenLabs');
    }
    // Implementação do ElevenLabs será adicionada aqui
    console.log('ElevenLabs speaking:', text);
  }

  async speak(text: string): Promise<void> {
    try {
      switch (this.provider) {
        case VOICE_PROVIDERS.ELEVENLABS:
          await this.elevenLabsSpeak(text);
          break;
        case VOICE_PROVIDERS.NATIVE:
        default:
          await this.nativeSpeak(text);
          break;
      }
    } catch (error) {
      console.error('Speech failed:', error);
      throw error;
    }
  }

  stop(): void {
    if (this.provider === VOICE_PROVIDERS.NATIVE) {
      window.speechSynthesis.cancel();
    }
    // Adicionar lógica para parar outros providers quando necessário
  }
}

export const voiceService = new VoiceService();